import {useCallback} from 'react';

type Ref<T> = React.MutableRefObject<T | null> | React.RefCallback<T | null> | null | undefined;

export function useCombinedRef<T>(...refs: Ref<T>[]) {
    const combinedRef = useCallback((value: T | null) => {
        return refs.forEach((ref) => {
            if (!ref) return;
            if (typeof ref === 'function') {
                ref(value);
            } else {
                ref.current = value;
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);

    return combinedRef;
}
